import { render } from "./RiSearch.vue?vue&type=template&id=7ca603b5"
import script from "./RiSearch.vue?vue&type=script&lang=js"
export * from "./RiSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ca603b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ca603b5', __exports__)) {
    api.reload('7ca603b5', __exports__)
  }
  
  module.hot.accept("./RiSearch.vue?vue&type=template&id=7ca603b5", () => {
    api.rerender('7ca603b5', render)
  })

}


export default __exports__